import { z } from 'zod';

export const FEATURE_FLAGS_SCHEMA = z.object({
  enableHomepage: z.boolean().optional(),
  enableChat: z.boolean().optional(),
  enableNls: z.boolean().optional(),
  enableDeepResearch: z.boolean().optional(),
  enableTranslate: z.boolean().optional(),
  enableExtensibleSummarize: z.boolean().optional(),
  enableExtensibleGenerate: z.boolean().optional(),
  enableLocalChatHistory: z.boolean().optional(),
  enableCollections: z.boolean().optional(),
});
export type FeatureFlags = z.infer<typeof FEATURE_FLAGS_SCHEMA>;

export type FeatureFlag = keyof FeatureFlags;

// A feature set can either be the special string literal `BETA` or a date-based
// identifier that follows the `YYMMNN` convention:
//
//   YY – last two digits of the year
//   MM – month (we start releasing in June → '06' … '12')
//   NN – release number within the month (currently we plan **two** releases → '00' | '01')
//
// Examples: '250600', '250601', '250700', '250701', ...
export enum FeatureSet {
  BETA = 'BETA',
  LEGACY = '1',
  JUNE_00 = '250600',
  JUNE_01 = '250601',
  JULY_00 = '250700',
  OCTOBER_00 = '251000',
}
